module.exports = __webpack_public_path__ + "static/media/logo_MKiDN_EN.3d404479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_MKiDN_EN.png
// module id = 1098
// module chunks = 0